export const formatCandidateIdentifierSearch = (searchKey: string) => {
	let cleanSearchKey = searchKey;
	cleanSearchKey = cleanSearchKey.replace(/https?\:\/\//gi, '').replace(/www./gi, '');
	return cleanSearchKey;
};
